module.exports = __webpack_public_path__ + "static/media/insurance_item-06.335a0a8c.svg";